const registry = new Map();
document.addEventListener('click', (e) => {
    registry.forEach((callback, el) => {
        if (!el.contains(e.target)) {
            callback();
        }
    });
});
const clickOutside = {
    bind(el, binding) {
        if (typeof binding.value === 'function') {
            registry.set(el, binding.value);
        }
    },
    unbind(el) {
        registry.delete(el);
    },
};
export default clickOutside;
